import Vuex from 'vuex';
import DeliveryProjectsTable from './stores/DeliveryProjectsTable';
import SalesProjectAddressesTable from './stores/SalesProjectAddressesTable';
import DeliveryProjectAddressesTable from './stores/DeliveryProjectAddressesTable';

export default new Vuex.Store({
    modules: {
        deliveryProjectsTable: DeliveryProjectsTable,
        salesProjectAddressesTable: SalesProjectAddressesTable,
        deliveryProjectAddressesTable: DeliveryProjectAddressesTable,
    },
});
